var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "button button-no-border button-outline-brand pdp-purchase-form-submit",
      class: {
        "button-light": !_vm.selectedProductType,
        "button-fill": _vm.selectedProductType,
        "button-segmented": _vm.isSubscriptionBuilder
      },
      attrs: { type: "submit" }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.buttonText))]),
      _vm._v(" "),
      _vm.isSubscriptionBuilder
        ? _c("svg", { staticClass: "icon icon-arrow-right" }, [
            _c("use", { attrs: { "xlink:href": "#icon-arrow-right" } })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }